import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../firebase";

/**
 * Registra una accion en el audit log inmutable (FIN-009).
 *
 * @param {string} action - Tipo de accion (ej: "approve_payment", "create_cierre", "delete_cierre")
 * @param {Object} details - Datos relevantes de la accion
 * @param {string|number} [details.buildingId] - ID del edificio
 * @param {string} [details.entityId] - ID de la entidad afectada
 * @param {string} [details.entityType] - Tipo de entidad (payment, cierre, expense, multa, alicuota)
 * @param {*} [details.previousValue] - Valor anterior (si aplica)
 * @param {*} [details.newValue] - Valor nuevo (si aplica)
 */
export async function logAudit(action, details = {}) {
  try {
    await addDoc(collection(db, "audit"), {
      action,
      ...details,
      performedBy: auth.currentUser?.email || "desconocido",
      performedByUid: auth.currentUser?.uid || null,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    // El audit log no debe bloquear la operacion principal
    console.error("Error registrando audit log:", err);
  }
}
